import React from "react";
import {
  Bar,
  BarChart,
  Cell,
  Label,
  ResponsiveContainer,
  XAxis,
  YAxis,
} from "recharts";

const HorizontalBarChart = ({
  data,
  dataKey = { x: "value", y: "name" },
  margin = {},
  barSize = 30,
  xLabel = "",
  yLabel = "",
}) => {
  return (
    <ResponsiveContainer width="100%" height="100%">
      <BarChart margin={margin} data={data} layout="vertical">
        <XAxis type="number" fontSize={14} tickLine={false}>
          <Label
            style={{ fill: "black", fontSize: "12px", fontWeight: "bold" }}
            value={xLabel}
            offset={-20}
            position="insideBottom"
          />
        </XAxis>
        <YAxis
          dataKey={dataKey.y}
          type="category"
          fontSize={14}
          tickLine={false}
        >
          <Label
            style={{ fill: "black", fontSize: "12px", fontWeight: "bold" }}
            value={yLabel}
            angle={-90}
            offset={-20}
            position="insideLeft"
          />
        </YAxis>
        <Bar
          dataKey={dataKey.x}
          barSize={barSize}
          radius={[0, 4, 4, 0]}
          label={{ position: "right", fontSize: "12px", fontWeight: 600 }}
        >
          {data.map((entry, index) => (
            <Cell key={`vertical-barchart-${index}`} fill={entry.color} />
          ))}
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
};

export default HorizontalBarChart;
